import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import SiteHeader from '../components/SiteHeader'
import Navigation from '../components/Navigation'
import NavigationDropdown from '../components/NavigationDropdown'
import CategoryLink from '../components/CategoryLink'
import ProductCategoryLink from '../components/ProductCategoryLink'
import ArticleContainer from '../components/ArticleContainer'
import ArticleLayout from '../components/ArticleLayout'
import ArticleHeader from '../components/ArticleHeader'
import PagesMainLayout from '../components/PagesMainLayout'
import Breadcrumb from '../components/Breadcrumb'
import NotificationBanner from '../components/NotificationBanner'
import { usePageViewTracking } from '../core'
import CategoryEnquiries from '../components/CategoryEnquiries'
import { SEO } from '../components/SEO'
import ButtonToTop from '../components/ButtonToTop'

const formCategories = {
  // Products: '/form/contact-us/products',
  Stores: '/form/contact-us/stores',
}

const formTitles = {
  Products: 'General product queries',
  Stores: 'General store queries',
}

const getCategoryFormURL = category => {
  return formCategories[category] || undefined
}

const getCategoryFormTitle = category => {
  return formTitles[category] || undefined
}

const propTypes = {
  pageContext: PropTypes.object,
  location: PropTypes.object,
}

const CategoryPage = ({
  data: { siteNavigation: currentCategoryMeta },
  pageContext,
}) => {
  usePageViewTracking()
  const { category } = pageContext
  const href = getCategoryFormURL(category)
  const title = getCategoryFormTitle(category)
  return (
    <>
      <SiteHeader search sticky />

      <NotificationBanner />

      <ArticleHeader currentCategory={category} />

      <ArticleContainer>
        <ButtonToTop />

        <ArticleLayout>
          <Navigation currentCategory={category} />
          <NavigationDropdown currentCategory={category} />
          <PagesMainLayout>
            <div className="mb-6">
              <Breadcrumb category={category} />
            </div>

            {/* <FAQCategory category={category} /> */}
            <h2 className="hidden w-full mb-6 text-3xl font-semibold lg:block">
              Browse questions
            </h2>
            <div className="flex flex-wrap mb-2 -mx-3">
              <ProductCategoryLink category={category} />
              {currentCategoryMeta.categoryData.map(item => (
                <CategoryLink item={item} key={item.slug} category={category} />
              ))}
            </div>
            {href && (
              <>
                <CategoryEnquiries href={href} title={title} />
              </>
            )}
          </PagesMainLayout>
        </ArticleLayout>
      </ArticleContainer>
    </>
  )
}

CategoryPage.propTypes = propTypes

export const query = graphql`
  query($category: String) {
    siteNavigation(Section_Name: { eq: $category }) {
      category: Section_Name
      displayOrder: DisplayOrder
      blurb: Section_Blurb
      categoryData: SubSections {
        slug: PageUrl
        title: SubSection_Name
        pageRef: PageReference
        blurb: SubSection_Blurb
        displayOrder: DisplayOrder
      }
    }
  }
`

export default CategoryPage

export const Head = ({ pageContext }) => {
  const { category } = pageContext
  return <SEO title={`${category} - Morrisons Help Hub`} />
}
